import Benefit from "v2/domain/benefits/entities/Benefit";
import CustomBenefit from "v2/domain/benefits/entities/CustomBenefit";
import { BenefitType } from "v2/infrastructure/Benefits/types/BenefitTypes";
import { BenefitModelInterface } from "../../repositories";

export default function restoreBenefits(benefit: BenefitModelInterface) {
  if (benefit.type === BenefitType.CUSTOM) {
    return new CustomBenefit(benefit);
  }

  return new Benefit(benefit);
}
